module.exports = __webpack_public_path__ + "media/last_ten_seconds_timer.112718e9.mp3";